module.exports = __webpack_public_path__ + "static/media/neko-disclaimer.24809186.png";